import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";

@Component({
    selector: "wbo-select-option",
    template: ""
})
export class SelectOptionComponent implements OnChanges {

    @Input() value: any;
    @Input() label: string;
    @Input() labelParams: any;

    @Output() dataChanged: EventEmitter<any> = new EventEmitter();

    ngOnChanges(changes: SimpleChanges): void {
        this.dataChanged.emit();
    }
}
